export const DDMMYY = 'DD/MM/YYYY'
export const FRIENDLY_DATE_1 = 'MMMM Do YYYY, h:mm:ss a'
export const FRIENDLY_DATE_2 = 'D-MMM-YYYY'
export const FRIENDLY_DATE_3 = 'DD-MMM YY, hh:mm a'
export const ONLY_TIME = 'hh:mm'
